import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setActiveDriver } from '../../Redux/slices/driverState'
import ScrollToTargetAdjusted from '../../Utils/ScrollToTargetAdjusted'
import AddDriver from './AddDriver'
import UpdateDriver from './UpdateDriver'
import ViewDrivers from './ViewDrivers'

export default function ManageDrivers () {
  const [editDriver,setEditDriver] = useState({docid:false})
  const dispatch = useDispatch()
  function setEditHandler(form){
    
    return ()=>{
      ScrollToTargetAdjusted("updateDriverForm")
      dispatch(setActiveDriver(null))
      setEditDriver(form)
    }
  }
  return (
    <div className='w-full flex flex-col'>
        <AddDriver/>
        <h1 className='ml-8 text-4xl font-medium'>Drivers</h1>
        <ViewDrivers setEditHandler={setEditHandler}/>
        {editDriver.docid&&<UpdateDriver formData={editDriver} setFormData={setEditDriver}/>}
    </div>
  )
}
